document.addEventListener('DOMContentLoaded', function() {

/* ╔════════════════════════════════════════════════════════════════╗
   ║  CONSTANTS & CONFIG                                          ║
   ╚════════════════════════════════════════════════════════════════╝ */

const CS = 100; // ClipperLib scale
const CUT_SMOOTH_TOL_MM = 1.0; // light RDP tolerance for cutout cut/clip boundaries — strips data-grid stairsteps without softening real shape features
const IN_TO_MM = 25.4;
const CUTOUT_DESIGN_REF_WMM = 7 * IN_TO_MM; // reference plaque width the cutout Layer-2 design (border width, caption size, text halo, caption position) is defined at (7in); the whole design scales together as export width changes, so exporting at a different size is a uniform scale-up/down, not a re-layout

const FONT_URLS = {
  'Dancing Script':'https://raw.githubusercontent.com/google/fonts/main/ofl/dancingscript/DancingScript%5Bwght%5D.ttf',
  'Great Vibes':'https://raw.githubusercontent.com/google/fonts/main/ofl/greatvibes/GreatVibes-Regular.ttf',
  'Parisienne':'https://raw.githubusercontent.com/google/fonts/main/ofl/parisienne/Parisienne-Regular.ttf',
  'Sacramento':'https://raw.githubusercontent.com/google/fonts/main/ofl/sacramento/Sacramento-Regular.ttf',
  'Pinyon Script':'https://raw.githubusercontent.com/google/fonts/main/ofl/pinyonscript/PinyonScript-Regular.ttf',
  'Cormorant Garamond':'https://raw.githubusercontent.com/google/fonts/main/ofl/cormorantgaramond/CormorantGaramond%5Bwght%5D.ttf',
  'Cinzel':'https://raw.githubusercontent.com/google/fonts/main/ofl/cinzel/Cinzel%5Bwght%5D.ttf',
  'Alex Brush':'https://raw.githubusercontent.com/google/fonts/main/ofl/alexbrush/AlexBrush-Regular.ttf',
  'Bebas Neue':'https://raw.githubusercontent.com/google/fonts/main/ofl/bebasneue/BebasNeue-Regular.ttf',
  'Montserrat':'https://raw.githubusercontent.com/google/fonts/main/ofl/montserrat/Montserrat%5Bwght%5D.ttf',
  'Raleway':'https://raw.githubusercontent.com/google/fonts/main/ofl/raleway/Raleway%5Bwght%5D.ttf',
  'Oswald':'https://raw.githubusercontent.com/google/fonts/main/ofl/oswald/Oswald%5Bwght%5D.ttf',
  'Lato':'https://raw.githubusercontent.com/google/fonts/main/ofl/lato/Lato-Regular.ttf',
};

const PIN_PATHS = {
  heart: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
  mappin: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
  house: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
};

const ROAD_WIDTHS = { motorway:1.2, trunk:1.0, primary:0.8, secondary:0.6, tertiary:0.45, minor:0.3, service:0.2, track:0.15, path:0.12 };

/* ── Silhouette data lookups ──────────────── */

// ISO 3166-1 alpha-2 → numeric (world-atlas keys)
const A2N = {
  AF:'004', AL:'008', DZ:'012', AS:'016', AD:'020', AO:'024', AI:'660', AQ:'010', AG:'028',
  AR:'032', AM:'051', AW:'533', AU:'036', AT:'040', AZ:'031', BS:'044', BH:'048', BD:'050',
  BB:'052', BY:'112', BE:'056', BZ:'084', BJ:'204', BM:'060', BT:'064', BO:'068', BA:'070',
  BW:'072', BV:'074', BR:'076', IO:'086', BN:'096', BG:'100', BF:'854', BI:'108', KH:'116',
  CM:'120', CA:'124', CV:'132', KY:'136', CF:'140', TD:'148', CL:'152', CN:'156', CX:'162',
  CC:'166', CO:'170', KM:'174', CG:'178', CD:'180', CK:'184', CR:'188', CI:'384', HR:'191',
  CU:'192', CY:'196', CZ:'203', DK:'208', DJ:'262', DM:'212', DO:'214', EC:'218', EG:'818',
  SV:'222', GQ:'226', ER:'232', EE:'233', ET:'231', FK:'238', FO:'234', FJ:'242', FI:'246',
  FR:'250', GF:'254', PF:'258', TF:'260', GA:'266', GM:'270', GE:'268', DE:'276', GH:'288',
  GI:'292', GR:'300', GL:'304', GD:'308', GP:'312', GU:'316', GT:'320', GG:'831', GN:'324',
  GW:'624', GY:'328', HT:'332', HM:'334', VA:'336', HN:'340', HK:'344', HU:'348', IS:'352',
  IN:'356', ID:'360', IR:'364', IQ:'368', IE:'372', IM:'833', IL:'376', IT:'380', JM:'388',
  JP:'392', JE:'832', JO:'400', KZ:'398', KE:'404', KI:'296', KP:'408', KR:'410', KW:'414',
  KG:'417', LA:'418', LV:'428', LB:'422', LS:'426', LR:'430', LY:'434', LI:'438', LT:'440',
  LU:'442', MO:'446', MK:'807', MG:'450', MW:'454', MY:'458', MV:'462', ML:'466', MT:'470',
  MH:'584', MQ:'474', MR:'478', MU:'480', YT:'175', MX:'484', FM:'583', MD:'498', MC:'492',
  MN:'496', ME:'499', MS:'500', MA:'504', MZ:'508', MM:'104', NA:'516', NR:'520', NP:'524',
  NL:'528', NC:'540', NZ:'554', NI:'558', NE:'562', NG:'566', NU:'570', NF:'574', MP:'580',
  NO:'578', OM:'512', PK:'586', PW:'585', PS:'275', PA:'591', PG:'598', PY:'600', PE:'604',
  PH:'608', PN:'612', PL:'616', PT:'620', PR:'630', QA:'634', RE:'638', RO:'642', RU:'643',
  RW:'646', BL:'652', SH:'654', KN:'659', LC:'662', MF:'663', PM:'666', VC:'670', WS:'882',
  SM:'674', ST:'678', SA:'682', SN:'686', RS:'688', SC:'690', SL:'694', SG:'702', SX:'534',
  SK:'703', SI:'705', SB:'090', SO:'706', ZA:'710', GS:'239', SS:'728', ES:'724', LK:'144',
  SD:'729', SR:'740', SJ:'744', SZ:'748', SE:'752', CH:'756', SY:'760', TW:'158', TJ:'762',
  TZ:'834', TH:'764', TL:'626', TG:'768', TK:'772', TO:'776', TT:'780', TN:'788', TR:'792',
  TM:'795', TC:'796', TV:'798', UG:'800', UA:'804', AE:'784', GB:'826', US:'840', UM:'581',
  UY:'858', UZ:'860', VU:'548', VE:'862', VN:'704', VG:'092', VI:'850', WF:'876', EH:'732',
  YE:'887', ZM:'894', ZW:'716',
};

const TERRITORY_NUM = {
  'Puerto Rico':'630', 'Greenland':'304', 'Hong Kong':'344', 'Macau':'446',
  'Western Sahara':'732', 'Kosovo':'383', 'Taiwan':'158', 'Guam':'316',
  'Northern Mariana Islands':'580', 'American Samoa':'016', 'Aruba':'533',
  'Curaçao':'531', 'New Caledonia':'540', 'French Polynesia':'258',
  'Falkland Islands':'238', 'Gibraltar':'292', 'Bermuda':'060',
};

const US_STATE_FIPS = {
  'Alabama':'01','Alaska':'02','Arizona':'04','Arkansas':'05','California':'06',
  'Colorado':'08','Connecticut':'09','Delaware':'10','District of Columbia':'11',
  'Florida':'12','Georgia':'13','Hawaii':'15','Idaho':'16','Illinois':'17',
  'Indiana':'18','Iowa':'19','Kansas':'20','Kentucky':'21','Louisiana':'22',
  'Maine':'23','Maryland':'24','Massachusetts':'25','Michigan':'26','Minnesota':'27',
  'Mississippi':'28','Missouri':'29','Montana':'30','Nebraska':'31','Nevada':'32',
  'New Hampshire':'33','New Jersey':'34','New Mexico':'35','New York':'36',
  'North Carolina':'37','North Dakota':'38','Ohio':'39','Oklahoma':'40','Oregon':'41',
  'Pennsylvania':'42','Rhode Island':'44','South Carolina':'45','South Dakota':'46',
  'Tennessee':'47','Texas':'48','Utah':'49','Vermont':'50','Virginia':'51',
  'Washington':'53','West Virginia':'54','Wisconsin':'55','Wyoming':'56',
};

/* ╔════════════════════════════════════════════════════════════════╗
   ║  STATE                                                       ║
   ╚════════════════════════════════════════════════════════════════╝ */

const S = {
  map: null,
  zoom: 14,
  detail: 'high',
  circleSize: 85,           // silhouette size % of plaque
  pin: 'heart',
  subtitle: 'Where It All Began',
  subtitleSize: 5,
  name: '',
  nameSize: 10,
  location: '',             // "Details" field — flexible: date, location, or anything else
  locationSize: 5,
  titleFont: 'Cinzel',
  nameFont: 'Dancing Script',
  lineSpacing: 1.2,
  width: 7,
  height: 7,
  unit: 'in',
  cornerRadius: 3,
  mainRoadWidth: 1.0,
  sideRoadWidth: 1.0,
  textOffset: -3,
  plaqueStyle: 'framed',    // 'framed' or 'cutout'
  pinSize: 1.0,             // multiplier on the auto-computed pin size
  silOffsetXmm: 0,          // horizontal shift of silhouette on plaque (mm, framed only)
  silOffsetYmm: 0,          // vertical shift of silhouette on plaque (mm, framed only)

  // ── Cutout Layer 2 (border ring + caption) ──
  borderWidthMm: 3,           // ring thickness (inward inset)
  cutoutCaption: '',          // one-word caption engraved on the border ring
  cutoutCaptionFont: 'Great Vibes',
  cutoutCaptionSize: 16,      // caption size at the reference plaque width (scales with export width — see CUTOUT_DESIGN_REF_WMM)
  cutoutTextOffsetMm: 3,      // halo added around each glyph before union with the ring
  cutoutCaptionOffsetXmm: 0,  // manual caption nudge, mm from default center-X
  cutoutCaptionOffsetYmm: 0,  // manual caption nudge, mm from default position (85% down the silhouette)

  // Silhouette state
  silhouette: null,          // { rings: [[[x,y],...],...] } in normalized [0..1]
  silhouetteAspect: 1,       // width/height ratio of the shape
  silhouetteName: '',        // display name of loaded place

  // Address state
  addressLngLat: null,       // { lng, lat } of address pin
};

const fontCache = {};
let worldAtlas = null;
let usAtlas = null;
let caAtlas = null;

/* ╔════════════════════════════════════════════════════════════════╗
   ║  DOM HELPERS                                                 ║
   ╚════════════════════════════════════════════════════════════════╝ */

const $ = id => document.getElementById(id);

function getWidthMm()  { return S.unit === 'in' ? S.width  * IN_TO_MM : S.width;  }
function getHeightMm() { return S.unit === 'in' ? S.height * IN_TO_MM : S.height; }

/* ╔════════════════════════════════════════════════════════════════╗
   ║  SILHOUETTE FETCHING                                         ║
   ╚════════════════════════════════════════════════════════════════╝ */

async function getJson(url, ms = 10000){
  const srcs = [
    () => fetch(url, { signal: AbortSignal.timeout(ms) }),
    () => fetch(`https://corsproxy.io/?url=${encodeURIComponent(url)}`, { signal: AbortSignal.timeout(ms) }),
    () => fetch(`https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`, { signal: AbortSignal.timeout(ms) }),
  ];
  for (const s of srcs) {
    try {
      const r = await s();
      if (!r.ok) continue;
      const t = await r.text();
      const j = JSON.parse(t);
      return (j && typeof j === 'object' && 'contents' in j) ? JSON.parse(j.contents) : j;
    } catch (_) {}
  }
  throw new Error('NETWORK_BLOCKED');
}

async function getWorldAtlas(){
  if (worldAtlas) return worldAtlas;
  const r = await fetch(
    'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-10m.json',
    { signal: AbortSignal.timeout(20000) }
  );
  worldAtlas = await r.json();
  return worldAtlas;
}

async function getUsAtlas(){
  if (usAtlas) return usAtlas;
  const r = await fetch(
    'https://cdn.jsdelivr.net/npm/us-atlas@3/counties-10m.json',
    { signal: AbortSignal.timeout(25000) }
  );
  usAtlas = await r.json();
  return usAtlas;
}

async function getCaAtlas(){
  if (caAtlas) return caAtlas;
  // deldersveld/topojson canada-provinces (StatCan-based, real detail)
  const r = await fetch(
    'https://cdn.jsdelivr.net/gh/deldersveld/topojson@master/countries/canada/canada-provinces.json',
    { signal: AbortSignal.timeout(25000) }
  );
  caAtlas = await r.json();
  return caAtlas;
}

function countryGeoFromAtlas(atlas, numeric){
  const fc = topojson.feature(atlas, atlas.objects.countries);
  return fc.features.find(f => String(f.id).padStart(3,'0') === String(numeric).padStart(3,'0')) || null;
}

function usStateGeoFromAtlas(atlas, fips){
  const fc = topojson.feature(atlas, atlas.objects.states);
  return fc.features.find(f => String(f.id).padStart(2,'0') === String(fips).padStart(2,'0')) || null;
}

// Match a Canadian province by name against deldersveld's topojson.
// Property names vary; try all common ones and normalize accents/case.
function caProvinceFromAtlas(atlas, label) {
  if (!atlas || !atlas.objects) return null;
  const objKey = Object.keys(atlas.objects)[0];
  const fc = topojson.feature(atlas, atlas.objects[objKey]);
  const nameProps = ['name','NAME','PRENAME','PRFNAME','PRENAME_E','province','Name','PROVINCE','PREABBR','PRABREV'];
  function norm(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  // Aliases (province → all acceptable variants)
  const aliases = {
    'quebec': ['quebec','québec'],
    'newfoundland': ['newfoundland','newfoundland and labrador'],
    'nwt': ['northwest territories'],
    'pei': ['prince edward island'],
    'bc': ['british columbia']
  };
  const targetN = norm(label);
  const aliasNs = (aliases[targetN] || [label]).map(norm);
  // Try exact/alias match on any property
  for (const f of fc.features) {
    for (const p of nameProps) {
      const val = f.properties[p];
      if (!val) continue;
      const vN = norm(val);
      if (vN === targetN || aliasNs.indexOf(vN) >= 0) return f;
    }
  }
  return null;
}

async function fetchShape(query) {
  // 1. Classify with Nominatim
  const nomUrl = `https://nominatim.openstreetmap.org/search`
    + `?q=${encodeURIComponent(query)}`
    + `&format=json&limit=1&addressdetails=1&polygon_geojson=0`;
  const nomData = await getJson(nomUrl, 8000);
  if (!nomData || !nomData.length) throw new Error('NOT_FOUND');
  const place = nomData[0];
  const label = place.display_name.split(',')[0].trim();
  const cc = place.address && place.address.country_code ? place.address.country_code.toUpperCase() : null;
  const isCountry = place.osm_type === 'relation' && (
    place.type === 'country' ||
    (place.address && place.address.country && label === place.address.country)
  );

  let geo = null;
  let displayName = label;

  // 2. Sovereign country → world-atlas
  if (isCountry && cc && A2N[cc]) {
    setStatus('silStatus', 'Loading country data…');
    const feature = countryGeoFromAtlas(await getWorldAtlas(), A2N[cc]);
    if (feature) { geo = feature.geometry; displayName = feature.properties.name || label; }
  }

  // 3. Territory → world-atlas by hardcoded ID
  if (!geo && TERRITORY_NUM[label]) {
    setStatus('silStatus', 'Loading territory data…');
    const feature = countryGeoFromAtlas(await getWorldAtlas(), TERRITORY_NUM[label]);
    if (feature) { geo = feature.geometry; displayName = feature.properties.name || label; }
  }

  // 4. US state → us-atlas
  if (!geo && cc === 'US' && US_STATE_FIPS[label]) {
    setStatus('silStatus', 'Loading state data…');
    try {
      const feature = usStateGeoFromAtlas(await getUsAtlas(), US_STATE_FIPS[label]);
      if (feature) { geo = feature.geometry; displayName = feature.properties.name || label; }
    } catch (e) { console.warn('US atlas failed', e); }
  }

  // 4b. Canadian province → canada-atlas
  if (!geo && cc === 'CA') {
    setStatus('silStatus', 'Loading Canadian province data…');
    try {
      const feature = caProvinceFromAtlas(await getCaAtlas(), label);
      if (feature) {
        geo = feature.geometry;
        const nm = feature.properties.name || feature.properties.NAME || feature.properties.PRENAME || feature.properties.PRENAME_E;
        if (nm) displayName = nm;
      }
    } catch (e) { console.warn('CA atlas failed, will try Nominatim:', e); }
  }

  // 5. Nominatim polygon fallback
  if (!geo) {
    setStatus('silStatus', 'Loading boundary (lower detail)…');
    const polyUrl = `https://nominatim.openstreetmap.org/search`
      + `?q=${encodeURIComponent(query)}&format=json&limit=1`
      + `&polygon_geojson=1&polygon_threshold=0`;
    const pd = await getJson(polyUrl, 12000);
    if (pd && pd[0] && pd[0].geojson) geo = pd[0].geojson;
  }

  if (!geo) throw new Error('NO_BOUNDARY');
  return { geo, displayName };
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  SILHOUETTE PROCESSING                                       ║
   ╚════════════════════════════════════════════════════════════════╝ */

// Extract outer rings from GeoJSON Polygon or MultiPolygon
function extractOuterRings(geo) {
  const rings = [];
  if (geo.type === 'Polygon') {
    rings.push(geo.coordinates[0]);  // outer ring only, ignore holes
  } else if (geo.type === 'MultiPolygon') {
    geo.coordinates.forEach(function(poly) { rings.push(poly[0]); });
  }
  return rings;
}

// Filter tiny outlying rings (e.g. distant offshore islets) if country
// Keep rings whose area is >= 0.5% of largest ring
function filterTinyRings(rings) {
  if (rings.length <= 1) return rings;
  const areas = rings.map(polyArea);
  const maxA = Math.max.apply(null, areas.map(Math.abs));
  const threshold = maxA * 0.005;
  return rings.filter(function(_, i) { return Math.abs(areas[i]) >= threshold; });
}

function polyArea(pts) {
  let a = 0;
  for (let i = 0, n = pts.length; i < n; i++) {
    const j = (i + 1) % n;
    a += pts[i][0] * pts[j][1] - pts[j][0] * pts[i][1];
  }
  return a / 2;
}

// Project lon/lat rings to normalized [0..1] using:
//   - Lambert Conformal Conic for large shapes (latRange ≥ 20°, same hemisphere): fixes Canada squish
//   - Equirectangular with cosLat correction for smaller shapes: better for states/provinces
// See "Map Projection Guide — Why Canada Doesn't Look Squished" for math and rationale.
function projectRingsToNorm(rings) {
  // Lon/lat bbox
  let mnX = Infinity, mxX = -Infinity, mnY = Infinity, mxY = -Infinity;
  rings.forEach(function(ring) {
    ring.forEach(function(pt) {
      if (pt[0] < mnX) mnX = pt[0];
      if (pt[0] > mxX) mxX = pt[0];
      if (pt[1] < mnY) mnY = pt[1];
      if (pt[1] > mxY) mxY = pt[1];
    });
  });
  const D2R = Math.PI / 180;
  const minLat = mnY, maxLat = mxY;
  const latRange = maxLat - minLat;
  const midLon = (mnX + mxX) / 2;
  const midLat = (minLat + maxLat) / 2;

  // Standard parallels at 1/6 and 5/6 of latitude range (the "1/6 rule")
  const phi1r = (minLat + latRange / 6) * D2R;
  const phi2r = (minLat + 5 * latRange / 6) * D2R;
  const phi0r = midLat * D2R;
  const lam0r = midLon * D2R;

  // Same-hemisphere guard (with small tolerance near the equator)
  const sameHemisphere = phi1r * phi2r > 0 || Math.abs(phi1r) < 0.01 || Math.abs(phi2r) < 0.01;
  const lccOk = sameHemisphere && latRange >= 20 && Math.abs(phi1r - phi2r) > 1e-4;

  let projFn = null;

  if (lccOk) {
    try {
      const cosP1 = Math.cos(phi1r), cosP2 = Math.cos(phi2r);
      const tanP1 = Math.tan(Math.PI/4 + phi1r/2);
      const tanP2 = Math.tan(Math.PI/4 + phi2r/2);
      if (cosP1 > 0 && cosP2 > 0 && tanP1 > 0 && tanP2 > 0) {
        const n = Math.log(cosP1 / cosP2) / Math.log(tanP2 / tanP1);
        if (isFinite(n) && Math.abs(n) > 0.05) {
          const F = cosP1 * Math.pow(tanP1, n) / n;
          const tan0 = Math.tan(Math.PI/4 + phi0r/2);
          if (tan0 > 0) {
            const rho0 = F / Math.pow(tan0, n);
            projFn = function(pt) {
              const lo = pt[0], la = pt[1];
              const ph = la * D2R;
              const lm = lo * D2R;
              const t = Math.tan(Math.PI/4 + ph/2);
              if (t <= 0) return [0, 0];
              const rho = F / Math.pow(t, n);
              const th = n * (lm - lam0r);
              // y = rho*cos(th) - rho0 → higher lat gives more negative y (north-up when SVG y-down)
              return [rho * Math.sin(th), rho * Math.cos(th) - rho0];
            };
          }
        }
      }
    } catch(e) { console.warn('LCC failed, falling back to cosLat:', e); }
  }

  if (!projFn) {
    // Equirectangular with cosLat clamp [0.20, 0.98]
    const cl = Math.min(0.98, Math.max(0.20, Math.cos(midLat * D2R)));
    projFn = function(pt) { return [(pt[0] - midLon) * cl, midLat - pt[1]]; };
  }

  // Project and compute bbox in projected space
  let pMinX = Infinity, pMaxX = -Infinity, pMinY = Infinity, pMaxY = -Infinity;
  const projected = rings.map(function(ring) {
    return ring.map(function(pt) {
      const p = projFn(pt);
      if (p[0] < pMinX) pMinX = p[0];
      if (p[0] > pMaxX) pMaxX = p[0];
      if (p[1] < pMinY) pMinY = p[1];
      if (p[1] > pMaxY) pMaxY = p[1];
      return p;
    });
  });

  const pW = pMaxX - pMinX;
  const pH = pMaxY - pMinY;
  const aspect = pW / (pH || 1e-6);

  // Normalize into unit square, centered
  const scale = Math.max(pW, pH);
  const offX = (scale - pW) / 2;
  const offY = (scale - pH) / 2;
  const norm = projected.map(function(ring) {
    return ring.map(function(pt) {
      return [(pt[0] - pMinX + offX) / scale, (pt[1] - pMinY + offY) / scale];
    });
  });
  return { rings: norm, aspect: aspect };
}

// RDP simplification for a single ring
function rdp(pts, tol) {
  if (pts.length < 3) return pts.slice();
  function distSq(p, a, b) {
    const dx = b[0]-a[0], dy = b[1]-a[1];
    const l2 = dx*dx+dy*dy;
    if (l2 < 1e-12) { const ex=p[0]-a[0], ey=p[1]-a[1]; return ex*ex+ey*ey; }
    let t = ((p[0]-a[0])*dx + (p[1]-a[1])*dy) / l2;
    t = Math.max(0, Math.min(1, t));
    const px = a[0]+t*dx, py = a[1]+t*dy;
    const ex = p[0]-px, ey = p[1]-py;
    return ex*ex + ey*ey;
  }
  function simplify(start, end, tol2, keep) {
    let maxD = 0, idx = -1;
    for (let i = start+1; i < end; i++) {
      const d = distSq(pts[i], pts[start], pts[end]);
      if (d > maxD) { maxD = d; idx = i; }
    }
    if (maxD > tol2 && idx > -1) {
      simplify(start, idx, tol2, keep);
      keep[idx] = true;
      simplify(idx, end, tol2, keep);
    }
  }
  const keep = new Array(pts.length).fill(false);
  keep[0] = true;
  keep[pts.length-1] = true;
  simplify(0, pts.length-1, tol*tol, keep);
  const out = [];
  for (let i = 0; i < pts.length; i++) if (keep[i]) out.push(pts[i]);
  return out;
}

// Chaikin corner-rounding smoothing (closed polyline)
function chaikin(pts, iter) {
  let cur = pts.slice();
  for (let k = 0; k < iter; k++) {
    const out = [];
    for (let i = 0, n = cur.length; i < n; i++) {
      const a = cur[i], b = cur[(i+1) % n];
      out.push([0.75*a[0] + 0.25*b[0], 0.75*a[1] + 0.25*b[1]]);
      out.push([0.25*a[0] + 0.75*b[0], 0.25*a[1] + 0.75*b[1]]);
    }
    cur = out;
  }
  return cur;
}

// Points → SVG "d" string (closed)
function pointsToD(pts) {
  if (!pts.length) return '';
  let d = 'M' + pts[0][0].toFixed(3) + ',' + pts[0][1].toFixed(3);
  for (let i = 1; i < pts.length; i++) d += ' L' + pts[i][0].toFixed(3) + ',' + pts[i][1].toFixed(3);
  return d + ' Z';
}

// Rings → single SVG "d" string (multiple subpaths)
function ringsToD(rings) {
  return rings.map(pointsToD).filter(Boolean).join(' ');
}

// Convert normalized rings to a plaque coordinate system, positioned inside a box
// Returns { rings: [[[x,y],...],...], bbox: {x,y,w,h} }
function silhouetteToMm(silhouette, boxX, boxY, boxW, boxH) {
  // Silhouette is in [0..1] × [0..1] normalized. It has aspect silhouetteAspect.
  // Fit into (boxW × boxH) preserving aspect.
  const sAsp = silhouette.aspect || 1;
  const bAsp = boxW / boxH;
  let w, h;
  if (sAsp > bAsp) { w = boxW; h = boxW / sAsp; }
  else { h = boxH; w = boxH * sAsp; }
  const offX = boxX + (boxW - w) / 2;
  const offY = boxY + (boxH - h) / 2;
  // Silhouette rings are normalized to unit square with aspect padding baked in.
  // The projected shape uses max(projW, projH) as denominator, so we scale by w/1 in the wider dimension.
  // Since it was normalized to unit square with padding, we need to re-fit.
  // Actually: after projectRingsToNorm, the shape sits centered in a unit square. To extract it at true aspect:
  // For an aspect-wide shape, x range is (0..1) fully; y range is (0.5 - 1/(2*aspect) .. 0.5 + 1/(2*aspect)).
  // For an aspect-tall shape, y range is (0..1); x range is (0.5 - aspect/2 .. 0.5 + aspect/2).
  // We'll just place it at aspect-correct proportions.
  const rings = silhouette.rings.map(function(ring) {
    return ring.map(function(pt) {
      // Un-pad: shift from centered in unit square back to (0..1 in longer dim, aspect-relative in shorter)
      let nx = pt[0], ny = pt[1];
      if (sAsp > 1) {
        // wider than tall: x uses full 0..1, y is compressed
        ny = (pt[1] - 0.5) * sAsp + 0.5;
      } else {
        nx = (pt[0] - 0.5) / sAsp + 0.5;
      }
      return [offX + nx * w, offY + ny * h];
    });
  });
  return { rings: rings, bbox: { x: offX, y: offY, w: w, h: h } };
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  UI: LOAD SILHOUETTE                                         ║
   ╚════════════════════════════════════════════════════════════════╝ */

function setStatus(elId, msg, isErr) {
  const el = $(elId);
  el.textContent = msg || '';
  el.classList.toggle('err', !!isErr);
}

async function loadSilhouette() {
  const q = $('silInput').value.trim();
  if (!q) { setStatus('silStatus', 'Please enter a place name', true); return; }
  $('silBtn').disabled = true;
  setStatus('silStatus', 'Searching…');
  try {
    const result = await fetchShape(q);
    let rings = extractOuterRings(result.geo);
    if (!rings.length) throw new Error('EMPTY_GEOMETRY');
    rings = filterTinyRings(rings);

    // Only strip absurd point counts — otherwise engraving handles full detail.
    const totalPts = rings.reduce(function(s, r) { return s + r.length; }, 0);
    if (totalPts > 15000) {
      rings = rings.map(function(r) { return rdp(r, 0.0004); });
    }

    // Project to normalized coords
    const norm = projectRingsToNorm(rings);
    S.silhouette = { rings: norm.rings, aspect: norm.aspect };
    S.silhouetteAspect = norm.aspect;
    S.silhouetteName = result.displayName;
    setStatus('silStatus', '✓ Loaded: ' + result.displayName);
    $('placeholderMsg').style.display = 'none';
    updateDimHint();
    updatePreview();
  } catch (err) {
    console.error('Silhouette load error:', err);
    let msg = 'Could not load shape';
    if (err.message === 'NETWORK_BLOCKED') msg = 'Network blocked. Try again or check your connection.';
    else if (err.message === 'NOT_FOUND') msg = 'No results found. Try a more specific name.';
    else if (err.message === 'NO_BOUNDARY') msg = 'No boundary data available for that place.';
    else if (err.message === 'EMPTY_GEOMETRY') msg = 'The boundary was empty. Try a different place.';
    else msg = 'Error: ' + err.message;
    setStatus('silStatus', msg, true);
  } finally {
    $('silBtn').disabled = false;
  }
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  MAP INIT                                                    ║
   ╚════════════════════════════════════════════════════════════════╝ */

function initMap() {
  S.map = new maplibregl.Map({
    container: 'map',
    style: 'https://tiles.openfreemap.org/styles/liberty',
    center: [-97, 38],
    zoom: 3,
    attributionControl: false
  });

  S.map.on('zoomend', function() {
    S.zoom = Math.round(S.map.getZoom() * 2) / 2;
    $('zoomSlider').value = S.zoom;
    $('zoomVal').textContent = S.zoom;
  });

  // Update pin overlay as user pans/zooms
  S.map.on('move', updatePinOverlay);

  S.map.on('load', function() {
    const style = S.map.getStyle();
    style.layers.forEach(function(layer) {
      const id = layer.id;
      const sl = layer['source-layer'] || '';
      const t = layer.type;

      if (t === 'background') {
        try { S.map.setPaintProperty(id, 'background-color', 'rgba(0,0,0,0)'); } catch(e){}
        return;
      }
      if (sl === 'water' && t === 'fill') {
        try { S.map.setPaintProperty(id, 'fill-color', '#7ec8e3'); S.map.setPaintProperty(id, 'fill-opacity', 0.55); } catch(e){}
        return;
      }
      if (sl === 'waterway' && (t === 'line' || t === 'fill')) {
        try { S.map.setPaintProperty(id, 'line-color', '#7ec8e3'); S.map.setPaintProperty(id, 'line-opacity', 0.6); } catch(e){}
        return;
      }
      if (sl === 'transportation' && t === 'line') {
        try { S.map.setPaintProperty(id, 'line-color', '#3d2e1e'); } catch(e){}
        try { S.map.setLayerZoomRange(id, 0, 24); } catch(e){}
        return;
      }
      try { S.map.removeLayer(id); } catch(e){}
    });

    // Overzoomed layers so minor roads are visible at low zoom
    const srcName = Object.keys(style.sources)[0] || 'openmaptiles';
    const origSrc = style.sources[srcName];
    try {
      S.map.addSource('ofm-overzoom', {
        type: 'vector',
        tiles: origSrc.tiles || ['https://tiles.openfreemap.org/planet/{z}/{x}/{y}.pbf'],
        minzoom: 12,
        maxzoom: 14
      });
      S.map.addLayer({
        id: 'ovz-minor-roads',
        type: 'line',
        source: 'ofm-overzoom',
        'source-layer': 'transportation',
        maxzoom: 12,
        filter: ['match', ['get', 'class'], ['minor','service','track','path','tertiary','residential','street','pedestrian'], true, false],
        paint: { 'line-color': '#3d2e1e', 'line-width': ['interpolate',['linear'],['zoom'], 5,0.08, 8,0.15, 11,0.4] }
      });
      S.map.addLayer({
        id: 'ovz-main-roads',
        type: 'line',
        source: 'ofm-overzoom',
        'source-layer': 'transportation',
        maxzoom: 12,
        filter: ['match', ['get', 'class'], ['motorway','trunk','primary','secondary'], true, false],
        paint: { 'line-color': '#3d2e1e', 'line-width': ['interpolate',['linear'],['zoom'], 5,0.3, 8,0.5, 11,1.2] }
      });
    } catch(e) { console.warn('Overzoom source failed:', e.message); }

    setDetail(S.detail);
    applyRoadWidths();
    S.map.resize();
  });

  S.map.on('error', function(e) { console.warn('Map error:', e.error || e); });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  GEOCODING (address)                                         ║
   ╚════════════════════════════════════════════════════════════════╝ */

async function searchAddress() {
  const q = $('addressInput').value.trim();
  if (!q) return;
  setStatus('searchStatus', 'Searching…');
  $('searchBtn').disabled = true;
  try {
    const resp = await fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(q));
    const data = await resp.json();
    if (data.length) {
      const r = data[0];
      const lng = parseFloat(r.lon), lat = parseFloat(r.lat);
      S.addressLngLat = { lng: lng, lat: lat };
      S.map.flyTo({ center: [lng, lat], zoom: S.zoom, duration: 1200 });
      S.map.once('moveend', function() { S.map.resize(); updatePinOverlay(); });
      setStatus('searchStatus', '✓ ' + r.display_name.split(',').slice(0,3).join(','));
    } else {
      setStatus('searchStatus', 'No results found.', true);
    }
  } catch(e) {
    setStatus('searchStatus', 'Search error. Try again.', true);
  }
  $('searchBtn').disabled = false;
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  PREVIEW RENDERING                                           ║
   ╚════════════════════════════════════════════════════════════════╝ */

// Cached layout, populated by updatePreview, used by updateTextPreview and updatePinOverlay
let _layout = null;

function updatePreview(skipResize) {
  const frame = $('boardFrame');
  const preview = $('plaquePreview');
  const wMm = getWidthMm(), hMm = getHeightMm();

  const isCutout = S.plaqueStyle === 'cutout';
  const sAsp = S.silhouetteAspect || 1;

  // Effective plaque bounds:
  //   Framed → user W×H (rectangle around silhouette + text room)
  //   Cutout → silhouette-shaped, W and derived H (no wasted space)
  let effWmm = wMm, effHmm = hMm;
  if (isCutout && S.silhouette) {
    effWmm = wMm;
    effHmm = wMm / sAsp;
  }
  const ratio = effWmm / effHmm;

  let pw, ph, scale;
  if (skipResize && _layout) {
    // Reused for controls that only change how the silhouette sits WITHIN the plaque
    // (e.g. Silhouette Size %) — re-measuring frame.clientWidth/clientHeight on every
    // slider tick is what caused the plaque box to visibly drift/grow during a drag.
    // The plaque's own pixel box only needs to change on true resize triggers (window
    // resize, dimension change, mode switch, silhouette load), which all call the
    // normal (skipResize=false) path below.
    pw = _layout.pw;
    ph = _layout.ph;
    scale = _layout.scale;
  } else {
    let availW = frame.clientWidth - 20;
    let availH = frame.clientHeight - 50;
    if (availW < 100) availW = 500;
    if (availH < 100) availH = 600;

    // Fill factor: cutout gets ~85% of the frame so it doesn't feel huge; framed uses everything.
    const fillFactor = isCutout ? 0.85 : 1.0;
    const useW = availW * fillFactor;
    const useH = availH * fillFactor;

    if (useW / useH > ratio) { ph = useH; pw = ph * ratio; }
    else { pw = useW; ph = pw / ratio; }
    if (pw < 50) { pw = 300; ph = pw / ratio; }

    preview.style.width = pw + 'px';
    preview.style.height = ph + 'px';
    scale = pw / effWmm;
  }

  // Framed-only + cutout-only slide-out containers, preview text, and export dims location
  const framed = $('framedContainer');
  const cutoutC = $('cutoutContainer');
  const dimsRow = $('exportDimsRow');
  const heightGroup = $('heightDimGroup');
  if (isCutout) {
    framed.classList.remove('open');
    cutoutC.classList.add('open');
    $('previewText').style.display = 'none';
    heightGroup.style.display = 'none'; // cutout: height is derived from silhouette aspect, not user-set
    // Move dims row to the bottom (before .btns)
    const anchor = $('exportDimsAnchor');
    if (dimsRow && dimsRow.parentNode !== anchor.parentNode) {
      anchor.parentNode.insertBefore(dimsRow, anchor);
    }
  } else {
    framed.classList.add('open');
    cutoutC.classList.remove('open');
    $('previewText').style.display = '';
    heightGroup.style.display = 'contents';
    // Move dims row into framedContainer just after the "Customize Plaque" header
    if (dimsRow && dimsRow.parentNode !== framed) {
      const hd = framed.querySelector('.framed-hd');
      framed.insertBefore(dimsRow, hd ? hd.nextSibling : framed.firstChild);
    }
  }

  // Silhouette layout:
  //   Framed → centered horizontally at top, capped to 85% of plaque height (was 68 — too restrictive)
  //   Cutout → fills the whole effective bounds (silLeftMm=0, silTopY=0)
  let silLeftMm, silTopY, silBoxWmm, silBoxHmm;
  if (isCutout && S.silhouette) {
    silLeftMm = 0; silTopY = 0;
    silBoxWmm = effWmm; silBoxHmm = effHmm;
  } else {
    const topPadMm = hMm * 0.06;
    const silCenterX = wMm / 2;
    // Space available for the silhouette (leave 15% of plaque height for text)
    const spaceWmm = wMm;
    const spaceHmm = hMm * 0.85;
    // Fit-to-space size (silhouette at 100%): whichever axis is binding wins
    let fitWmm, fitHmm;
    if (spaceWmm / spaceHmm > sAsp) {
      // Height-binding
      fitHmm = spaceHmm;
      fitWmm = fitHmm * sAsp;
    } else {
      // Width-binding
      fitWmm = spaceWmm;
      fitHmm = fitWmm / sAsp;
    }
    // Apply user's Silhouette Size % — every value now has an effect
    const k = S.circleSize / 100;
    silBoxWmm = fitWmm * k;
    silBoxHmm = fitHmm * k;
    silTopY = topPadMm + S.silOffsetYmm;
    silLeftMm = silCenterX - silBoxWmm / 2 + S.silOffsetXmm;
  }
  const silBottomMm = silTopY + silBoxHmm;

  // Beige plaque background: framed = rectangle with corner radius; cutout = silhouette-shaped (via clip-path)
  preview.style.background = '#d8d2c0';
  if (isCutout) {
    preview.style.borderRadius = '0';
    preview.style.boxShadow = 'none';
    preview.style.filter = 'drop-shadow(0 6px 16px rgba(0,0,0,.14))';
  } else {
    const crPx = S.cornerRadius * scale;
    preview.style.borderRadius = crPx + 'px';
    preview.style.boxShadow = '0 6px 30px rgba(0,0,0,.12)';
    preview.style.filter = '';
  }

  // Map area covers silhouette bounding box
  const mapWrap = $('mapWrap');
  mapWrap.style.left = (silLeftMm * scale) + 'px';
  mapWrap.style.top = (silTopY * scale) + 'px';
  mapWrap.style.width = (silBoxWmm * scale) + 'px';
  mapWrap.style.height = (silBoxHmm * scale) + 'px';

  _layout = { pw: pw, ph: ph, scale: scale, wMm: effWmm, hMm: effHmm,
              silLeftMm: silLeftMm, silTopY: silTopY,
              silBoxWmm: silBoxWmm, silBoxHmm: silBoxHmm,
              silBottomMm: silBottomMm, sAsp: sAsp, isCutout: isCutout };

  // Silhouette clip-paths (map-wrap AND, in cutout mode, the entire plaque-preview so beige is silhouette-shaped)
  const ov = $('previewOverlay');
  ov.setAttribute('viewBox', '0 0 ' + pw + ' ' + ph);
  let svgInner = '';
  let capInner = '';

  if (S.silhouette) {
    // Silhouette rings in preview px (absolute) and map-wrap-local px.
    // Cutout mode: lightly smoothed to strip data-grid stairsteps from the cut boundary
    // (matches the same smoothing applied in downloadSVG so preview = export).
    let silMm = silhouetteToMm(S.silhouette, silLeftMm, silTopY, silBoxWmm, silBoxHmm);
    if (isCutout) {
      silMm = { rings: silMm.rings.map(function(r) { return rdp(r, CUT_SMOOTH_TOL_MM); }) };
    }
    const silPx = silMm.rings.map(function(r) { return r.map(function(p) { return [p[0] * scale, p[1] * scale]; }); });
    const mapOffX = silLeftMm * scale;
    const mapOffY = silTopY * scale;

    // Map-wrap clip-path (silhouette relative to map-wrap origin)
    const mapClipD = silPx.map(function(r) {
      let d = 'M';
      r.forEach(function(p, i) { d += (i === 0 ? '' : ' L') + (p[0]-mapOffX).toFixed(2) + ',' + (p[1]-mapOffY).toFixed(2); });
      return d + ' Z';
    }).join(' ');
    mapWrap.style.clipPath = 'path("' + mapClipD + '")';
    mapWrap.style.webkitClipPath = 'path("' + mapClipD + '")';

    // Cutout: clip the whole plaque-preview to silhouette so its beige only shows within the shape
    if (isCutout) {
      const prevClipD = silPx.map(function(r) {
        let d = 'M';
        r.forEach(function(p, i) { d += (i === 0 ? '' : ' L') + p[0].toFixed(2) + ',' + p[1].toFixed(2); });
        return d + ' Z';
      }).join(' ');
      preview.style.clipPath = 'path("' + prevClipD + '")';
      preview.style.webkitClipPath = 'path("' + prevClipD + '")';
    } else {
      preview.style.clipPath = 'none';
      preview.style.webkitClipPath = 'none';
    }

    // Cutout: darker border ring (drawn as a thick stroke along the silhouette outline;
    // the parent .plaque-preview is clip-path'd to this same outline, so the outward half
    // of the stroke is clipped away automatically — approximates an inset ring with zero
    // ClipperLib calls, keeping slider drags fast).
    // Border width is defined at the reference plaque width and scales with export width,
    // same as everything else on Layer 2 — the whole design scales together as one unit.
    const designScale = effWmm / CUTOUT_DESIGN_REF_WMM;
    if (isCutout) {
      let borderD = '';
      silPx.forEach(function(r) { borderD += pointsToD(r) + ' '; });
      const effBorderMm = S.borderWidthMm * designScale;
      const borderStrokePx = effBorderMm * 2 * scale;
      svgInner += '<path id="cutoutBorderStroke" d="' + borderD.trim() + '" fill="none" stroke="#baa988" stroke-width="' + borderStrokePx.toFixed(2) + '" stroke-linejoin="round"/>';
    }

    // Silhouette outline: framed = brown (engrave tone), cutout = thin light brown
    const outlineColor = isCutout ? '#8b7355' : '#3d2e1e';
    const outlineWidth = isCutout ? 0.8 : 1.1;
    silPx.forEach(function(r) {
      svgInner += '<path d="' + pointsToD(r) + '" fill="none" stroke="' + outlineColor + '" stroke-width="' + outlineWidth + '"/>';
    });

    // Cutout: caption text with a stroke "halo" approximating the offset weld
    // (exact geometry is only computed once, at export time, via ClipperLib).
    // Rendered into the SEPARATE, unclipped #previewCaptionOverlay — not svgInner —
    // so it stays fully visible even when it falls outside the silhouette shape.
    if (isCutout) {
      const cap = (S.cutoutCaption || '').trim();
      // Position offsets, size, and halo are all defined at the reference plaque width
      // and scale together with export width — exporting at a different size is a
      // uniform scale of the same design, not an independent re-layout of each piece.
      const cx = (silLeftMm + silBoxWmm / 2 + S.cutoutCaptionOffsetXmm * designScale) * scale;
      const cy = (silTopY + silBoxHmm * 0.85 + S.cutoutCaptionOffsetYmm * designScale) * scale;
      const effCapSizeMm = S.cutoutCaptionSize * designScale;
      const sizePx = effCapSizeMm * scale;
      const haloPx = S.cutoutTextOffsetMm * designScale * 2 * scale;
      const safeCap = cap.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      capInner = '<text id="cutoutCaptionText" x="' + cx.toFixed(1) + '" y="' + cy.toFixed(1) +
        '" text-anchor="middle" dominant-baseline="alphabetic"' +
        ' font-family="\'' + S.cutoutCaptionFont + '\', serif"' +
        ' font-size="' + sizePx.toFixed(1) + '"' +
        ' fill="#1a1a1a" stroke="#baa988" stroke-width="' + haloPx.toFixed(2) + '" stroke-linejoin="round" paint-order="stroke fill">' + safeCap + '</text>';
    }
  } else {
    mapWrap.style.clipPath = 'none';
    mapWrap.style.webkitClipPath = 'none';
    preview.style.clipPath = 'none';
    preview.style.webkitClipPath = 'none';
  }

  // Pin in its own <g> so updatePinOverlay can retarget without a full rebuild
  svgInner += '<g id="previewPinGroup"></g>';
  ov.innerHTML = svgInner;

  // Unclipped caption overlay: measure .plaque-preview's actual position within
  // .board-frame (not a CSS percentage guess — the "Drag to pan" hint above it
  // shifts the flex-centered vertical position) so the overlay tracks it exactly.
  const capOv = $('previewCaptionOverlay');
  const previewRect = preview.getBoundingClientRect();
  const frameRect = frame.getBoundingClientRect();
  const previewOffsetLeft = previewRect.left - frameRect.left;
  const previewOffsetTop = previewRect.top - frameRect.top;
  capOv.style.left = previewOffsetLeft + 'px';
  capOv.style.top = previewOffsetTop + 'px';
  capOv.style.width = pw + 'px';
  capOv.style.height = ph + 'px';
  capOv.setAttribute('viewBox', '0 0 ' + pw + ' ' + ph);
  capOv.innerHTML = capInner;

  // Same trick for the framed-mode text overlay — same measured box, same reasoning:
  // living outside .plaque-preview means overflow:hidden can't clip script-font swashes.
  const textOv = $('previewText');
  textOv.style.left = previewOffsetLeft + 'px';
  textOv.style.width = pw + 'px';

  _layout.previewOffsetLeft = previewOffsetLeft;
  _layout.previewOffsetTop = previewOffsetTop;

  updateTextPreview();
  updatePinOverlay();

  if (S.map) setTimeout(function() { S.map.resize(); }, 50);
}

function updateTextPreview() {
  if (!_layout) return;
  const L = _layout;
  const textEl = $('previewText');
  if (L.isCutout) { textEl.style.display = 'none'; return; }
  textEl.style.display = '';
  const textTop = (L.previewOffsetTop || 0) + (L.silBottomMm + L.hMm * 0.03 + S.textOffset) * L.scale;
  textEl.style.top = textTop + 'px';

  const lines = [];
  if (S.subtitle) lines.push({ el: $('ptSubtitle'), size: S.subtitleSize, font: S.titleFont, text: S.subtitle.toUpperCase() });
  if (S.name)     lines.push({ el: $('ptName'),     size: S.nameSize,     font: S.nameFont,  text: S.name });
  if (S.location) lines.push({ el: $('ptLocation'), size: S.locationSize, font: S.titleFont, text: S.location });
  ['ptSubtitle','ptName','ptLocation'].forEach(function(id) { $(id).style.display = 'none'; });
  lines.forEach(function(ln) {
    ln.el.style.display = 'block';
    ln.el.textContent = ln.text;
    ln.el.style.fontFamily = "'" + ln.font + "', serif";
    const fsPx = ln.size * L.scale;
    ln.el.style.fontSize = fsPx + 'px';
    ln.el.style.marginBottom = (fsPx * (S.lineSpacing - 1)) + 'px';
  });
}

function updatePinOverlay() {
  if (!_layout || !S.silhouette) return;
  const g = $('previewPinGroup');
  if (!g) return;
  const L = _layout;
  const pinPos = computePinPreviewPos(L.silLeftMm, L.silTopY, L.silBoxWmm, L.silBoxHmm, L.scale);
  if (!pinPos) { g.innerHTML = ''; return; }
  const pinScale = (Math.min(L.silBoxWmm, L.silBoxHmm) * 0.06) * L.scale / 24 * S.pinSize;
  const pinD = PIN_PATHS[S.pin];
  const pinColor = S.pin === 'heart' ? '#c0392b' : '#3d2e1e';
  const backerR = 14 * pinScale;
  let html = '';
  html += '<circle cx="' + pinPos.x.toFixed(1) + '" cy="' + pinPos.y.toFixed(1) + '" r="' + backerR.toFixed(1) + '" fill="#d8d2c0" stroke="none"/>';
  html += '<g transform="translate(' + (pinPos.x - 12*pinScale).toFixed(2) + ',' + (pinPos.y - 12*pinScale).toFixed(2) + ') scale(' + pinScale.toFixed(4) + ')">';
  html += '<path d="' + pinD + '" fill="' + pinColor + '"/></g>';
  g.innerHTML = html;
}

function computePinPreviewPos(silLeftMm, silTopY, silBoxWmm, silBoxHmm, scale) {
  if (!S.addressLngLat || !S.map) return null;
  const px = S.map.project([S.addressLngLat.lng, S.addressLngLat.lat]);
  const mapEl = $('map');
  const mapWpx = mapEl.clientWidth;
  const mapHpx = mapEl.clientHeight;
  if (!mapWpx || !mapHpx) return null;
  const fracX = px.x / mapWpx;
  const fracY = px.y / mapHpx;
  const plaqueXmm = silLeftMm + fracX * silBoxWmm;
  const plaqueYmm = silTopY + fracY * silBoxHmm;
  return { x: plaqueXmm * scale, y: plaqueYmm * scale };
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  DETAIL LEVEL & ROAD WIDTHS                                  ║
   ╚════════════════════════════════════════════════════════════════╝ */

function setDetail(level) {
  S.detail = level;
  if (!S.map || !S.map.isStyleLoaded()) return;
  const style = S.map.getStyle();
  if (!style || !style.layers) return;
  style.layers.forEach(function(layer) {
    const id = layer.id.toLowerCase();
    const isMinor = id.indexOf('minor') >= 0 || id.indexOf('service') >= 0 || id.indexOf('track') >= 0 || id.indexOf('path') >= 0;
    const isTertiary = id.indexOf('tertiary') >= 0;
    if (isMinor) { try { S.map.setLayoutProperty(layer.id, 'visibility', level === 'high' ? 'visible' : 'none'); } catch(e){} }
    if (isTertiary) { try { S.map.setLayoutProperty(layer.id, 'visibility', level === 'low' ? 'none' : 'visible'); } catch(e){} }
  });
  try { S.map.setLayoutProperty('ovz-minor-roads', 'visibility', level === 'high' ? 'visible' : 'none'); } catch(e){}
}

function applyRoadWidths() {
  if (!S.map || !S.map.isStyleLoaded()) return;
  const style = S.map.getStyle();
  if (!style || !style.layers) return;
  style.layers.forEach(function(layer) {
    if (layer['source-layer'] !== 'transportation' || layer.type !== 'line') return;
    const id = layer.id;
    const idL = id.toLowerCase();
    const isMain = idL.indexOf('motorway') >= 0 || idL.indexOf('trunk') >= 0 || idL.indexOf('primary') >= 0 || idL.indexOf('secondary') >= 0;
    const isSide = idL.indexOf('tertiary') >= 0 || idL.indexOf('minor') >= 0 || idL.indexOf('service') >= 0 || idL.indexOf('track') >= 0 || idL.indexOf('path') >= 0 || idL.indexOf('residential') >= 0 || idL.indexOf('street') >= 0 || idL.indexOf('pedestrian') >= 0;
    if (!isMain && !isSide) return;
    const m = isMain ? S.mainRoadWidth : S.sideRoadWidth;
    try {
      // Disable the paint-property transition so width changes apply instantly.
      // Without this, MapLibre eases over ~300ms by default; dragging the slider
      // quickly re-triggers a new transition mid-flight, which can visually dip
      // thinner before catching up to the target width.
      S.map.setPaintProperty(id, 'line-width-transition', { duration: 0, delay: 0 });
      if (isMain) S.map.setPaintProperty(id, 'line-width', ['interpolate',['linear'],['zoom'], 5,0.3*m, 8,0.5*m, 12,1.8*m, 16,4.5*m]);
      else S.map.setPaintProperty(id, 'line-width', ['interpolate',['linear'],['zoom'], 5,0.1*m, 8,0.15*m, 12,0.5*m, 14,0.7*m, 16,1.8*m]);
    } catch(e) {}
  });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  SEGMENT CONTROL HELPER                                      ║
   ╚════════════════════════════════════════════════════════════════╝ */

function initSeg(containerId, callback) {
  const el = $(containerId);
  el.querySelectorAll('.sb').forEach(function(btn) {
    btn.addEventListener('click', function() {
      el.querySelectorAll('.sb').forEach(function(b){ b.classList.remove('on'); });
      btn.classList.add('on');
      callback(btn.dataset.v);
    });
  });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  FONT SETTERS & SIZE ADJUSTERS                               ║
   ╚════════════════════════════════════════════════════════════════╝ */

function setTitleFont(f) { S.titleFont = f; $('titleFontSelect').style.fontFamily = "'" + f + "', sans-serif"; updateTextPreview(); }
function setNameFont(f) { S.nameFont = f; $('nameInput').style.fontFamily = "'" + f + "', cursive"; $('nameFontSelect').style.fontFamily = "'" + f + "', cursive"; updateTextPreview(); }

function adjSize(field, delta) {
  const key = field + 'Size';
  S[key] = Math.max(2, Math.min(60, S[key] + delta));
  $(field + 'SizeVal').textContent = S[key];
  updateTextPreview();
}
function adjTextOffset(delta) {
  S.textOffset = Math.max(-30, Math.min(30, S.textOffset + delta));
  $('textOffsetVal').textContent = S.textOffset;
  updateTextPreview();
}
function updateCornerOnly() {
  // Just update the visual border-radius on the preview — no full layout recompute.
  // Full updatePreview reads frame.clientWidth/Height and can drift the preview size on rapid updates.
  if (!_layout) return;
  if (S.plaqueStyle === 'cutout') return;
  const preview = $('plaquePreview');
  const crPx = S.cornerRadius * _layout.scale;
  preview.style.borderRadius = crPx + 'px';
}
function updateCutoutOverlay() {
  // Fast path for border width / caption text / font / size / halo / position changes.
  // Only touches attributes on the existing #cutoutBorderStroke and #cutoutCaptionText
  // elements — no full layout recompute, no ClipperLib calls. Keeps slider drags smooth.
  if (!_layout || !_layout.isCutout || !S.silhouette) return;
  const L = _layout;
  const designScale = L.wMm / CUTOUT_DESIGN_REF_WMM;
  const borderEl = document.getElementById('cutoutBorderStroke');
  if (borderEl) {
    borderEl.setAttribute('stroke-width', (S.borderWidthMm * designScale * 2 * L.scale).toFixed(2));
  }
  const capEl = document.getElementById('cutoutCaptionText');
  if (capEl) {
    const cap = (S.cutoutCaption || '').trim();
    const cx = (L.silLeftMm + L.silBoxWmm / 2 + S.cutoutCaptionOffsetXmm * designScale) * L.scale;
    const cy = (L.silTopY + L.silBoxHmm * 0.85 + S.cutoutCaptionOffsetYmm * designScale) * L.scale;
    const effCapSizeMm = S.cutoutCaptionSize * designScale;
    const sizePx = effCapSizeMm * L.scale;
    const haloPx = S.cutoutTextOffsetMm * designScale * 2 * L.scale;
    capEl.setAttribute('x', cx.toFixed(1));
    capEl.setAttribute('y', cy.toFixed(1));
    capEl.setAttribute('font-size', sizePx.toFixed(1));
    capEl.setAttribute('font-family', "'" + S.cutoutCaptionFont + "', serif");
    capEl.setAttribute('stroke-width', haloPx.toFixed(2));
    capEl.textContent = cap;
  }
}
function adjPinSize(delta) {
  S.pinSize = Math.max(0.3, Math.min(3.0, +(S.pinSize + delta * 0.1).toFixed(2)));
  $('pinSizeVal').textContent = Math.round(S.pinSize * 100) + '%';
  updatePinOverlay();
}
function adjSilPos(axis, delta) {
  const step = 2; // mm per click
  const cap = 60;
  if (axis === 'x') {
    S.silOffsetXmm = Math.max(-cap, Math.min(cap, S.silOffsetXmm + delta * step));
    $('silPosXVal').textContent = S.silOffsetXmm + ' mm';
  } else {
    S.silOffsetYmm = Math.max(-cap, Math.min(cap, S.silOffsetYmm + delta * step));
    $('silPosYVal').textContent = S.silOffsetYmm + ' mm';
  }
  updatePreview(true);
}
function adjBorderWidth(delta) {
  S.borderWidthMm = Math.max(0.5, Math.min(15, +(S.borderWidthMm + delta * 0.5).toFixed(1)));
  $('borderWidthVal').textContent = S.borderWidthMm.toFixed(1) + ' mm';
  updateCutoutOverlay();
}
function adjCutoutCaptionSize(delta) {
  S.cutoutCaptionSize = Math.max(3, Math.min(30, S.cutoutCaptionSize + delta));
  $('cutoutCaptionSizeVal').textContent = S.cutoutCaptionSize;
  updateCutoutOverlay();
}
function adjCutoutTextOffset(delta) {
  S.cutoutTextOffsetMm = Math.max(0, Math.min(10, +(S.cutoutTextOffsetMm + delta * 0.5).toFixed(1)));
  $('cutoutTextOffsetVal').textContent = S.cutoutTextOffsetMm.toFixed(1) + ' mm';
  updateCutoutOverlay();
}
function adjCutoutCaptionPos(axis, delta) {
  const step = 2, cap = 80;
  if (axis === 'x') {
    S.cutoutCaptionOffsetXmm = Math.max(-cap, Math.min(cap, S.cutoutCaptionOffsetXmm + delta * step));
    $('cutoutCapXVal').textContent = S.cutoutCaptionOffsetXmm + ' mm';
  } else {
    S.cutoutCaptionOffsetYmm = Math.max(-cap, Math.min(cap, S.cutoutCaptionOffsetYmm + delta * step));
    $('cutoutCapYVal').textContent = S.cutoutCaptionOffsetYmm + ' mm';
  }
  updateCutoutOverlay();
}
function setCutoutCaptionFont(f) {
  S.cutoutCaptionFont = f;
  const input = $('cutoutCaptionInput');
  input.style.fontFamily = "'" + f + "', serif";
  updateCutoutOverlay();
}
function adjDim(dim, delta) {
  const step = S.unit === 'in' ? 0.5 : 5;
  const min = S.unit === 'in' ? 2 : 50;
  const max = S.unit === 'in' ? 24 : 600;
  S[dim] = Math.max(min, Math.min(max, S[dim] + delta * step));
  $(dim + 'Val').textContent = S[dim];
  updateDimHint();
  updatePreview();
}
function updateDimHint() {
  const w = getWidthMm(), h = getHeightMm();
  const isCutout = S.plaqueStyle === 'cutout';
  const effH = isCutout ? (w / (S.silhouetteAspect || 1)) : h;
  const suffix = isCutout ? ' (H auto)' : '';
  if (S.unit === 'in') $('dimHint').textContent = '≈ ' + (w/IN_TO_MM).toFixed(2) + ' × ' + (effH/IN_TO_MM).toFixed(2) + ' in' + suffix;
  else $('dimHint').textContent = '≈ ' + w.toFixed(1) + ' × ' + effH.toFixed(1) + ' mm' + suffix;
}
function switchUnit(u) {
  if (u === S.unit) return;
  if (u === 'mm') { S.width = Math.round(S.width * IN_TO_MM); S.height = Math.round(S.height * IN_TO_MM); }
  else {
    S.width = Math.round(S.width / IN_TO_MM * 2) / 2;
    S.height = Math.round(S.height / IN_TO_MM * 2) / 2;
    if (S.width < 2) S.width = 2;
    if (S.height < 2) S.height = 2;
  }
  S.unit = u;
  $('widthVal').textContent = S.width;
  $('heightVal').textContent = S.height;
  updateDimHint();
  updatePreview();
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  RESET                                                       ║
   ╚════════════════════════════════════════════════════════════════╝ */

function resetAll() {
  $('silInput').value = ''; setStatus('silStatus', '');
  S.silhouette = null; S.silhouetteName = ''; S.silhouetteAspect = 1;
  $('placeholderMsg').style.display = '';
  $('addressInput').value = ''; setStatus('searchStatus', ''); S.addressLngLat = null;
  $('subtitleInput').value = 'Where It All Began'; S.subtitle = 'Where It All Began'; S.subtitleSize = 5; $('subtitleSizeVal').textContent = '5';
  $('nameInput').value = ''; S.name = ''; S.nameSize = 10; $('nameSizeVal').textContent = '10';
  $('locationInput').value = ''; S.location = ''; S.locationSize = 5; $('locationSizeVal').textContent = '5';
  $('zoomSlider').value = 14; S.zoom = 14; $('zoomVal').textContent = '14';
  $('mapSizeSlider').value = 85; S.circleSize = 85; $('mapSizeVal').textContent = '85%';
  $('cornerSlider').value = 3; S.cornerRadius = 3; $('cornerVal').textContent = '3 mm';
  $('lineSpacingSlider').value = 1.2; S.lineSpacing = 1.2; $('lineSpacingVal').textContent = '1.2×';
  S.textOffset = -3; $('textOffsetVal').textContent = '-3';
  S.pinSize = 1.0; $('pinSizeVal').textContent = '100%';
  S.silOffsetXmm = 0; $('silPosXVal').textContent = '0 mm';
  S.silOffsetYmm = 0; $('silPosYVal').textContent = '0 mm';
  S.borderWidthMm = 3; $('borderWidthVal').textContent = '3.0 mm';
  S.cutoutCaption = ''; $('cutoutCaptionInput').value = '';
  S.cutoutCaptionFont = 'Great Vibes'; $('cutoutCaptionFontSelect').value = 'Great Vibes';
  S.cutoutCaptionSize = 16; $('cutoutCaptionSizeVal').textContent = '16';
  S.cutoutTextOffsetMm = 3; $('cutoutTextOffsetVal').textContent = '3.0 mm';
  S.cutoutCaptionOffsetXmm = 0; $('cutoutCapXVal').textContent = '0 mm';
  S.cutoutCaptionOffsetYmm = 0; $('cutoutCapYVal').textContent = '0 mm';
  S.mainRoadWidth = 1.0; $('mainRoadSlider').value = 1; $('mainRoadVal').textContent = '1.0×';
  S.sideRoadWidth = 1.0; $('sideRoadSlider').value = 1; $('sideRoadVal').textContent = '1.0×';
  S.titleFont = 'Cinzel'; $('titleFontSelect').value = 'Cinzel'; setTitleFont('Cinzel');
  S.nameFont = 'Dancing Script'; $('nameFontSelect').value = 'Dancing Script'; setNameFont('Dancing Script');
  S.detail = 'high'; setDetail('high');
  $('detailSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='high'); });
  S.pin = 'heart';
  $('pinSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='heart'); });
  S.plaqueStyle = 'framed';
  $('plaqueStyleSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='framed'); });
  switchUnit('in'); S.width = 7; S.height = 7;
  $('unitSeg').querySelectorAll('.sb').forEach(function(b){ b.classList.toggle('on', b.dataset.v==='in'); });
  $('widthVal').textContent = '7'; $('heightVal').textContent = '7';
  updateDimHint();
  applyRoadWidths();
  if (S.map) S.map.flyTo({ center:[-97,38], zoom:3, duration:800 });
  updatePreview();
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  CLIPPER HELPERS                                             ║
   ╚════════════════════════════════════════════════════════════════╝ */

function hasClipper() {
  try { return typeof ClipperLib !== 'undefined' && typeof ClipperLib.Clipper === 'function'; } catch(e) { return false; }
}
function toCP(pts) { return pts.map(function(p){ return { X: Math.round(p[0]*CS), Y: Math.round(p[1]*CS) }; }); }
function fromCP(path) { return path.map(function(p){ return [p.X/CS, p.Y/CS]; }); }

function clipperIntersect(subjectPaths, clipRings) {
  if (!hasClipper() || !subjectPaths.length) return [];
  const cpr = new ClipperLib.Clipper();
  cpr.AddPaths(subjectPaths, ClipperLib.PolyType.ptSubject, true);
  clipRings.forEach(function(r) { cpr.AddPath(toCP(r), ClipperLib.PolyType.ptClip, true); });
  const sol = new ClipperLib.Paths();
  cpr.Execute(ClipperLib.ClipType.ctIntersection, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  return sol;
}

function offsetLine(coords, width) {
  if (!hasClipper() || coords.length < 2) return null;
  const co = new ClipperLib.ClipperOffset(2, 0.25 * CS);
  co.AddPath(toCP(coords), ClipperLib.JoinType.jtRound, ClipperLib.EndType.etOpenRound);
  const sol = new ClipperLib.Paths();
  co.Execute(sol, width * CS / 2);
  return sol.length ? sol : null;
}

function makeCirclePoly(cx, cy, r, n) {
  const pts = [];
  for (let i = 0; i < n; i++) { const a = 2*Math.PI*i/n; pts.push([cx + r*Math.cos(a), cy + r*Math.sin(a)]); }
  return pts;
}

function pathsToD(paths) {
  return paths.map(function(p) {
    const pts = (p[0] && typeof p[0].X !== 'undefined') ? fromCP(p) : p;
    if (pts.length < 2) return '';
    let d = 'M' + pts[0][0].toFixed(3) + ',' + pts[0][1].toFixed(3);
    for (let i = 1; i < pts.length; i++) d += ' L' + pts[i][0].toFixed(3) + ',' + pts[i][1].toFixed(3);
    return d + ' Z';
  }).filter(Boolean).join(' ');
}

// Inset closed polygons inward by `mm` (positive shrinks). Returns rings in mm units, or null if the offset destroys the shape.
function computeInsetRings(ringsMm, mm) {
  if (!hasClipper() || !ringsMm || !ringsMm.length || mm <= 0) return null;
  try {
    const co = new ClipperLib.ClipperOffset(2, 0.25 * CS);
    ringsMm.forEach(function(r) {
      co.AddPath(toCP(r), ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
    });
    const sol = new ClipperLib.Paths();
    co.Execute(sol, -mm * CS);
    if (!sol.length) return null;
    return sol.map(function(p) { return fromCP(p); });
  } catch (e) { console.warn('inset failed', e); return null; }
}

// Union a set of closed polygon paths (each in ClipperLib IntPoint format). Returns Paths (IntPoint).
function clipperUnionPaths(pathsList) {
  if (!hasClipper() || !pathsList.length) return [];
  const cpr = new ClipperLib.Clipper();
  cpr.AddPaths(pathsList, ClipperLib.PolyType.ptSubject, true);
  const sol = new ClipperLib.Paths();
  cpr.Execute(ClipperLib.ClipType.ctUnion, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  return sol;
}

// A DIFFERENCE B, both in IntPoint format. Returns IntPoint Paths.
function clipperDifference(subjectPaths, clipPaths) {
  if (!hasClipper() || !subjectPaths.length) return [];
  const cpr = new ClipperLib.Clipper();
  cpr.AddPaths(subjectPaths, ClipperLib.PolyType.ptSubject, true);
  if (clipPaths.length) cpr.AddPaths(clipPaths, ClipperLib.PolyType.ptClip, true);
  const sol = new ClipperLib.Paths();
  cpr.Execute(ClipperLib.ClipType.ctDifference, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
  return sol;
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  BEZIER FLATTENING                                           ║
   ╚════════════════════════════════════════════════════════════════╝ */

function _splitCubic(x0,y0,x1,y1,x2,y2,x3,y3,tol,pts){
  const dx=x3-x0, dy=y3-y0, l2=dx*dx+dy*dy;
  if(l2<0.001){pts.push([x3,y3]);return;}
  const d1=Math.abs((x1-x0)*dy-(y1-y0)*dx);
  const d2=Math.abs((x2-x0)*dy-(y2-y0)*dx);
  if((d1+d2)*(d1+d2)<=tol*tol*4*l2){pts.push([x3,y3]);return;}
  const ax=(x0+x1)/2,ay=(y0+y1)/2,bx=(x1+x2)/2,by=(y1+y2)/2;
  const cx2=(x2+x3)/2,cy2=(y2+y3)/2,dx2=(ax+bx)/2,dy2=(ay+by)/2;
  const ex=(bx+cx2)/2,ey=(by+cy2)/2,mx=(dx2+ex)/2,my=(dy2+ey)/2;
  _splitCubic(x0,y0,ax,ay,dx2,dy2,mx,my,tol,pts);
  _splitCubic(mx,my,ex,ey,cx2,cy2,x3,y3,tol,pts);
}
function _splitQuad(x0,y0,x1,y1,x2,y2,tol,pts){
  _splitCubic(x0,y0, x0+(x1-x0)*2/3,y0+(y1-y0)*2/3, x2+(x1-x2)*2/3,y2+(y1-y2)*2/3, x2,y2, tol, pts);
}
function flattenCmds(cmds, tol) {
  const out=[]; let cur=null, px=0, py=0;
  for (let i=0;i<cmds.length;i++){
    const c = cmds[i];
    switch(c.type){
      case 'M': if(cur&&cur.length>1) out.push(cur); cur=[[c.x,c.y]]; px=c.x; py=c.y; break;
      case 'L': if(cur) cur.push([c.x,c.y]); px=c.x; py=c.y; break;
      case 'C': if(cur) _splitCubic(px,py,c.x1,c.y1,c.x2,c.y2,c.x,c.y,tol,cur); px=c.x; py=c.y; break;
      case 'Q': if(cur) _splitQuad(px,py,c.x1,c.y1,c.x,c.y,tol,cur); px=c.x; py=c.y; break;
      case 'Z': if(cur&&cur.length>1) out.push(cur); cur=null; break;
    }
  }
  if(cur&&cur.length>1) out.push(cur);
  return out;
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  FONT LOADING                                                ║
   ╚════════════════════════════════════════════════════════════════╝ */

async function loadFont(name) {
  if (fontCache[name]) return fontCache[name];
  const url = FONT_URLS[name];
  if (!url) throw new Error('No URL for font: ' + name);
  return new Promise(function(resolve, reject) {
    opentype.load(url, function(err, font) {
      if (err) { reject(new Error('Font load failed: ' + name + ' - ' + err)); return; }
      fontCache[name] = font;
      resolve(font);
    });
  });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  SVG EXPORT                                                  ║
   ╚════════════════════════════════════════════════════════════════╝ */

async function downloadSVG() {
  const dlBtn = $('dlBtn');
  dlBtn.disabled = true;
  dlBtn.textContent = 'Generating…';

  try {
    if (!S.map) throw new Error('Map not loaded');
    if (!S.silhouette) throw new Error('Load a silhouette shape first');

    const wMm = getWidthMm(), hMm = getHeightMm();
    const cornerMm = S.cornerRadius;
    const isCutout = S.plaqueStyle === 'cutout';
    const sAsp = S.silhouetteAspect || 1;

    // Effective plaque bounds — must match updatePreview
    const effWmm = isCutout ? wMm : wMm;
    const effHmm = isCutout ? (wMm / sAsp) : hMm;

    // Silhouette layout
    let silLeftMm, silTopY, silBoxWmm, silBoxHmm;
    if (isCutout) {
      silLeftMm = 0; silTopY = 0;
      silBoxWmm = effWmm; silBoxHmm = effHmm;
    } else {
      const topPadMm = hMm * 0.06;
      const silCenterX = wMm / 2;
      const spaceWmm = wMm;
      const spaceHmm = hMm * 0.85;
      let fitWmm, fitHmm;
      if (spaceWmm / spaceHmm > sAsp) {
        fitHmm = spaceHmm;
        fitWmm = fitHmm * sAsp;
      } else {
        fitWmm = spaceWmm;
        fitHmm = fitWmm / sAsp;
      }
      const k = S.circleSize / 100;
      silBoxWmm = fitWmm * k;
      silBoxHmm = fitHmm * k;
      silTopY = topPadMm + S.silOffsetYmm;
      silLeftMm = silCenterX - silBoxWmm / 2 + S.silOffsetXmm;
    }

    // Silhouette rings in plaque mm — lightly smoothed for cutout mode to remove
    // sub-mm data-grid stairsteps from the physical cut/clip boundary (real geographic
    // detail is preserved; only axis-aligned survey/raster artifacts get stripped).
    const silMm = silhouetteToMm(S.silhouette, silLeftMm, silTopY, silBoxWmm, silBoxHmm);
    const silRings = isCutout
      ? silMm.rings.map(function(r) { return rdp(r, CUT_SMOOTH_TOL_MM); })
      : silMm.rings;

    // Build projector: map lng/lat → plaque mm
    const map = S.map;
    const mapEl = $('map');
    const mapWpx = mapEl.clientWidth;
    const mapHpx = mapEl.clientHeight;
    function proj(lngLat) {
      const px = map.project(lngLat);
      const fracX = px.x / mapWpx;
      const fracY = px.y / mapHpx;
      return [silLeftMm + fracX * silBoxWmm, silTopY + fracY * silBoxHmm];
    }

    // ── Extract roads ──
    let roadFeatures = [];
    try {
      const allLayers = map.getStyle().layers;
      const transportLayers = allLayers.filter(function(l) {
        return l['source-layer'] === 'transportation' && (l.type === 'line' || l.type === 'fill');
      }).map(function(l) { return l.id; });
      if (transportLayers.length) {
        roadFeatures = map.queryRenderedFeatures(undefined, { layers: transportLayers });
      }
    } catch(e) { console.warn('Road extraction error:', e); }

    const roadPolys = [];
    roadFeatures.forEach(function(f) {
      const cls = f.properties.class || 'minor';
      let w = ROAD_WIDTHS[cls] || 0.3;
      const isMain = cls === 'motorway' || cls === 'trunk' || cls === 'primary' || cls === 'secondary';
      w *= isMain ? S.mainRoadWidth : S.sideRoadWidth;
      let lines = [];
      if (f.geometry.type === 'LineString') lines.push(f.geometry.coordinates);
      else if (f.geometry.type === 'MultiLineString') lines = f.geometry.coordinates;
      lines.forEach(function(coords) {
        const mmCoords = coords.map(function(c){ return proj({lng:c[0],lat:c[1]}); });
        const polys = offsetLine(mmCoords, w);
        if (polys) polys.forEach(function(p){ roadPolys.push(p); });
      });
    });

    // Union roads
    let roadUnion = [];
    if (roadPolys.length && hasClipper()) {
      const cpr = new ClipperLib.Clipper();
      const simplified = ClipperLib.Clipper.SimplifyPolygons(roadPolys, ClipperLib.PolyFillType.pftNonZero);
      cpr.AddPaths(simplified, ClipperLib.PolyType.ptSubject, true);
      const sol = new ClipperLib.Paths();
      cpr.Execute(ClipperLib.ClipType.ctUnion, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      roadUnion = ClipperLib.Clipper.CleanPolygons(sol, 0.05 * CS);
    }

    // Clip roads to silhouette shape (all rings)
    const roadClipped = clipperIntersect(roadUnion, silRings);

    // ── Extract water ──
    let waterFeatures = [];
    try {
      const allLayers2 = map.getStyle().layers;
      const waterLayers = allLayers2.filter(function(l) {
        return l['source-layer'] === 'water' && l.type === 'fill';
      }).map(function(l) { return l.id; });
      if (waterLayers.length) {
        waterFeatures = map.queryRenderedFeatures(undefined, { layers: waterLayers });
      }
    } catch(e) {}

    const waterPolys = [];
    waterFeatures.forEach(function(f) {
      let polys = [];
      if (f.geometry.type === 'Polygon') polys.push(f.geometry.coordinates);
      else if (f.geometry.type === 'MultiPolygon') polys = f.geometry.coordinates;
      polys.forEach(function(rings) {
        rings.forEach(function(ring) {
          const mmRing = ring.map(function(c){ return proj({lng:c[0],lat:c[1]}); });
          if (mmRing.length > 2) waterPolys.push(toCP(mmRing));
        });
      });
    });

    let waterUnion = [];
    if (waterPolys.length && hasClipper()) {
      const wcpr = new ClipperLib.Clipper();
      wcpr.AddPaths(waterPolys, ClipperLib.PolyType.ptSubject, true);
      const wsol = new ClipperLib.Paths();
      wcpr.Execute(ClipperLib.ClipType.ctUnion, wsol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      waterUnion = wsol;
    }
    let waterClipped = waterUnion.length ? clipperIntersect(waterUnion, silRings) : [];

    // ── Waterway lines ──
    let waterwayFeatures = [];
    if (S.detail !== 'low') {
      try {
        const allLayers3 = map.getStyle().layers;
        const wwLayers = allLayers3.filter(function(l) {
          return l['source-layer'] === 'waterway' && (l.type === 'line' || l.type === 'fill');
        }).map(function(l) { return l.id; });
        if (wwLayers.length) {
          waterwayFeatures = map.queryRenderedFeatures(undefined, { layers: wwLayers });
        }
      } catch(e) {}
    }
    const waterwayPolys = [];
    waterwayFeatures.forEach(function(f) {
      let lines = [];
      if (f.geometry.type === 'LineString') lines.push(f.geometry.coordinates);
      else if (f.geometry.type === 'MultiLineString') lines = f.geometry.coordinates;
      lines.forEach(function(coords) {
        const mmCoords = coords.map(function(c){ return proj({lng:c[0],lat:c[1]}); });
        const polys = offsetLine(mmCoords, 0.8);
        if (polys) polys.forEach(function(p){ waterwayPolys.push(p); });
      });
    });
    if (waterwayPolys.length && hasClipper()) {
      const allWater = waterClipped.concat(waterwayPolys);
      const wwcpr = new ClipperLib.Clipper();
      wwcpr.AddPaths(allWater, ClipperLib.PolyType.ptSubject, true);
      const wwsol = new ClipperLib.Paths();
      wwcpr.Execute(ClipperLib.ClipType.ctUnion, wwsol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      waterClipped = clipperIntersect(wwsol, silRings);
    }

    // ── Text paths (framed mode only) ──
    const textSvgPaths = [];

    // Load caption font up front for cutout mode
    if (isCutout && (S.cutoutCaption || '').trim()) {
      await loadFont(S.cutoutCaptionFont);
    }

    if (!isCutout) {
    const BOLD_PCT = {'Cinzel':0.020,'Montserrat':0.040,'Raleway':0.035,'Oswald':0.025,'Lato':0.020,'Bebas Neue':0.010};
    const SPACING_FACTOR = {'subtitle':0.10,'location':0.04};

    const textLines = [];
    if (S.subtitle) textLines.push({ text: S.subtitle.toUpperCase(), size: S.subtitleSize, font: S.titleFont, role:'subtitle' });
    if (S.name) textLines.push({ text: S.name, size: S.nameSize, font: S.nameFont, role:'name' });
    if (S.location) textLines.push({ text: S.location, size: S.locationSize, font: S.titleFont, role:'location' });

    const neededFonts = {};
    textLines.forEach(function(l){ neededFonts[l.font] = true; });
    const fontNames = Object.keys(neededFonts);
    for (let fi = 0; fi < fontNames.length; fi++) await loadFont(fontNames[fi]);

    const silBottomMm = silTopY + silBoxHmm;
    const textStartY = silBottomMm + hMm * 0.03 + S.textOffset;
    let divY = textStartY;
    const lineBaselines = [];
    for (let lbi = 0; lbi < textLines.length; lbi++) {
      const lsz = textLines[lbi].size;
      const baseline = divY + lsz * 0.85;
      lineBaselines.push(baseline);
      const divH = lsz * 1.3;
      const margin = lsz * Math.max(0, S.lineSpacing - 1);
      divY += divH + margin;
    }

    for (let li = 0; li < textLines.length; li++) {
      const ln = textLines[li];
      const fnt = fontCache[ln.font];
      if (!fnt) continue;
      const letterSpace = (SPACING_FACTOR[ln.role] || 0) * ln.size;
      const allContours = [];
      let penX = 0;
      for (let ci = 0; ci < ln.text.length; ci++) {
        const glyph = fnt.charToGlyph(ln.text[ci]);
        if (!glyph || glyph.index === 0) { penX += ln.size * 0.3; continue; }
        const gPath = glyph.getPath(penX, 0, ln.size);
        const gc = flattenCmds(gPath.commands, 0.02);
        gc.forEach(function(c){ if(c.length > 2) allContours.push(c); });
        let adv = (glyph.advanceWidth || 500) / fnt.unitsPerEm * ln.size;
        if (ci < ln.text.length - 1) {
          const nextG = fnt.charToGlyph(ln.text[ci + 1]);
          const kern = fnt.getKerningValue(glyph, nextG);
          adv += kern / fnt.unitsPerEm * ln.size;
        }
        penX += adv + letterSpace;
      }
      const textW = penX - letterSpace;
      if (!allContours.length) continue;
      const offX = (wMm - textW) / 2;
      const offY = lineBaselines[li];
      allContours.forEach(function(c){ for(let p=0;p<c.length;p++){ c[p][0]+=offX; c[p][1]+=offY; }});
      if (hasClipper()) {
        const cpaths = allContours.map(function(c){ return toCP(c); });
        const tcpr = new ClipperLib.Clipper();
        tcpr.AddPaths(cpaths, ClipperLib.PolyType.ptSubject, true);
        let tsol = new ClipperLib.Paths();
        tcpr.Execute(ClipperLib.ClipType.ctUnion, tsol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        const bPct = BOLD_PCT[ln.font] || 0;
        if (bPct > 0) {
          const bOff = ln.size * bPct;
          const co = new ClipperLib.ClipperOffset(2, 0.1 * CS);
          co.AddPaths(tsol, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
          const expanded = new ClipperLib.Paths();
          co.Execute(expanded, bOff * CS);
          tsol = expanded;
        }
        const td = pathsToD(tsol);
        if (td) textSvgPaths.push(td);
      }
    }
    } // end !isCutout text block

    // ── Pin ──
    const pinRefSize = Math.min(silBoxWmm, silBoxHmm);
    const pinSizeMm = pinRefSize * 0.06 * S.pinSize;
    const pinScale = pinSizeMm / 24;
    const pinD = PIN_PATHS[S.pin];
    let pinPosMm = null;
    if (S.addressLngLat) {
      pinPosMm = proj({lng: S.addressLngLat.lng, lat: S.addressLngLat.lat});
    }
    // Only place pin if it falls inside silhouette bounds (roughly)
    let pinTx = null, pinTy = null;
    if (pinPosMm) {
      pinTx = pinPosMm[0] - 12 * pinScale;
      pinTy = pinPosMm[1] - 12 * pinScale;
    }

    // ── Knock out roads around pin ──
    if (pinPosMm && roadClipped.length && hasClipper()) {
      const pinKnockoutR = 14 * pinScale;
      const pinKnockoutPoly = makeCirclePoly(pinPosMm[0], pinPosMm[1], pinKnockoutR, 48);
      const koCpr = new ClipperLib.Clipper();
      koCpr.AddPaths(roadClipped, ClipperLib.PolyType.ptSubject, true);
      koCpr.AddPath(toCP(pinKnockoutPoly), ClipperLib.PolyType.ptClip, true);
      const koSol = new ClipperLib.Paths();
      koCpr.Execute(ClipperLib.ClipType.ctDifference, koSol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      // Reassign
      while (roadClipped.length) roadClipped.pop();
      koSol.forEach(function(p){ roadClipped.push(p); });
    }

    // Silhouette outline — used as CUT (cutout) or SCORE (framed). Exact — engraving/scoring can handle full detail.
    const silOutlineMm = silRings;

    // ── Layer 2 for cutout mode: border ring + caption text engrave + text halo unioned into the cut ──
    // Border width, caption size, halo offset, and caption position are all defined at the
    // reference plaque width (CUTOUT_DESIGN_REF_WMM) and scale together as one design —
    // exporting at a different width is a uniform scale, not an independent re-layout.
    let layer2 = null;
    const designScale = effWmm / CUTOUT_DESIGN_REF_WMM;
    const effBorderWidthMm = S.borderWidthMm * designScale;
    if (isCutout && S.silhouette && effBorderWidthMm > 0 && hasClipper()) {
      const insetRingsMm = computeInsetRings(silRings, effBorderWidthMm);
      if (insetRingsMm && insetRingsMm.length) {
        const silCP = silRings.map(toCP);
        const insetCP = insetRingsMm.map(toCP);
        const borderRingCP = clipperDifference(silCP, insetCP);

        // Caption glyph contours → Clipper paths, then union
        let textEngraveCP = [];
        let textHaloCP = [];
        const cap = (S.cutoutCaption || '').trim();
        if (cap && fontCache[S.cutoutCaptionFont]) {
          const fnt = fontCache[S.cutoutCaptionFont];
          const size = S.cutoutCaptionSize * designScale;
          let penX = 0;
          const contours = [];
          for (let ci = 0; ci < cap.length; ci++) {
            const glyph = fnt.charToGlyph(cap[ci]);
            if (!glyph || glyph.index === 0) { penX += size * 0.3; continue; }
            const gPath = glyph.getPath(penX, 0, size);
            const gc = flattenCmds(gPath.commands, 0.02);
            gc.forEach(function(c) { if (c.length > 2) contours.push(c); });
            let adv = (glyph.advanceWidth || 500) / fnt.unitsPerEm * size;
            if (ci < cap.length - 1) {
              const nextG = fnt.charToGlyph(cap[ci + 1]);
              const kern = fnt.getKerningValue(glyph, nextG);
              adv += kern / fnt.unitsPerEm * size;
            }
            penX += adv;
          }
          const textW = penX;
          const textCenterX = silLeftMm + silBoxWmm / 2 + S.cutoutCaptionOffsetXmm * designScale;
          const textBaselineY = silTopY + silBoxHmm * 0.85 + S.cutoutCaptionOffsetYmm * designScale;
          const offX = textCenterX - textW / 2;
          const offY = textBaselineY;
          contours.forEach(function(c) {
            for (let p = 0; p < c.length; p++) { c[p][0] += offX; c[p][1] += offY; }
          });

          if (contours.length) {
            const cpaths = contours.map(toCP);
            textEngraveCP = clipperUnionPaths(cpaths);

            const effHaloMm = S.cutoutTextOffsetMm * designScale;
            if (effHaloMm > 0 && textEngraveCP.length) {
              const co = new ClipperLib.ClipperOffset(2, 0.1 * CS);
              co.AddPaths(textEngraveCP, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
              const expanded = new ClipperLib.Paths();
              co.Execute(expanded, effHaloMm * CS);
              textHaloCP = expanded;
            } else {
              textHaloCP = textEngraveCP;
            }
          }
        }

        // Weld border ring with text halo (union)
        let layer2CutCP;
        if (textHaloCP.length && borderRingCP.length) {
          const uCpr = new ClipperLib.Clipper();
          uCpr.AddPaths(borderRingCP, ClipperLib.PolyType.ptSubject, true);
          uCpr.AddPaths(textHaloCP, ClipperLib.PolyType.ptClip, true);
          const uSol = new ClipperLib.Paths();
          uCpr.Execute(ClipperLib.ClipType.ctUnion, uSol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
          layer2CutCP = uSol;
        } else {
          layer2CutCP = borderRingCP;
        }

        layer2 = {
          cutD: pathsToD(layer2CutCP),
          engraveD: textEngraveCP.length ? pathsToD(textEngraveCP) : ''
        };
      }
    }

    // ── Assemble SVG ──
    const pad = 5;
    const guideH = 14;
    const layer2Gap = 8;                            // mm between Layer 1 and Layer 2
    const layer2OffsetX = layer2 ? (effWmm + layer2Gap) : 0;
    const svgW = effWmm + layer2OffsetX + pad * 2;
    const svgH = effHmm + pad * 2 + guideH;

    const svg = [];
    svg.push('<?xml version="1.0" encoding="UTF-8"?>');
    const svgHeaderComment = isCutout
      ? '<!-- Silhouette Map Plaque SVG — RED=#FF0000 CUT  BLACK=#000000 ENGRAVE  LTBLUE=#7EC8E3 LIGHT ENGRAVE -->'
      : '<!-- Silhouette Map Plaque SVG — RED=#FF0000 CUT  BLUE=#0000FF SCORE  BLACK=#000000 ENGRAVE  LTBLUE=#7EC8E3 LIGHT ENGRAVE -->';
    svg.push(svgHeaderComment);
    svg.push('<svg xmlns="http://www.w3.org/2000/svg" width="' + svgW.toFixed(2) + 'mm" height="' + svgH.toFixed(2) + 'mm" viewBox="' + (-pad) + ' ' + (-pad) + ' ' + svgW.toFixed(2) + ' ' + svgH.toFixed(2) + '">');

    // Cut line: rectangle (framed) or silhouette (cutout)
    if (!isCutout) {
      svg.push('<rect x="0" y="0" width="' + wMm.toFixed(3) + '" height="' + hMm.toFixed(3) + '" rx="' + cornerMm.toFixed(2) + '" ry="' + cornerMm.toFixed(2) + '" fill="none" stroke="#FF0000" stroke-width="0.1"/>');
      // Silhouette outline as SCORE (blue) — laser guide for the shape boundary
      svg.push('<path d="' + ringsToD(silOutlineMm) + '" fill="none" stroke="#0000FF" stroke-width="0.1"/>');
    } else {
      // Cutout: silhouette outline is the CUT (red)
      svg.push('<path d="' + ringsToD(silOutlineMm) + '" fill="none" stroke="#FF0000" stroke-width="0.1"/>');
    }

    // Water — LIGHT ENGRAVE
    if (waterClipped.length) {
      const waterD = pathsToD(waterClipped);
      if (waterD) svg.push('<path d="' + waterD + '" fill="#7EC8E3" stroke="none" fill-rule="evenodd"/>');
    }

    // Roads — ENGRAVE
    if (roadClipped.length) {
      const roadD = pathsToD(roadClipped);
      if (roadD) svg.push('<path d="' + roadD + '" fill="#000000" stroke="none" fill-rule="evenodd"/>');
    }

    // Pin — ENGRAVE
    if (pinTx !== null) {
      svg.push('<g transform="translate(' + pinTx.toFixed(3) + ',' + pinTy.toFixed(3) + ') scale(' + pinScale.toFixed(5) + ')">');
      svg.push('<path d="' + pinD + '" fill="#000000"/>');
      svg.push('</g>');
    }

    // Text — ENGRAVE (framed mode only)
    if (!isCutout) {
      textSvgPaths.forEach(function(d) { svg.push('<path d="' + d + '" fill="#000000" stroke="none" fill-rule="evenodd"/>'); });
    }

    // ── Layer 2 (cutout mode): border ring welded with caption text halo ──
    if (layer2) {
      svg.push('<g transform="translate(' + layer2OffsetX.toFixed(2) + ', 0)">');
      if (layer2.cutD) {
        svg.push('<path d="' + layer2.cutD + '" fill="none" stroke="#FF0000" stroke-width="0.1"/>');
      }
      if (layer2.engraveD) {
        svg.push('<path d="' + layer2.engraveD + '" fill="#000000" stroke="none" fill-rule="evenodd"/>');
      }
      svg.push('</g>');
    }

    // Guide legend
    const gy = effHmm + 6;
    const gcx = (effWmm + layer2OffsetX + effWmm * (layer2 ? 1 : 0)) / (layer2 ? 2 : 1) / (layer2 ? 1 : 1);
    // Simpler: center the legend across the full occupied content span
    const legendCenterX = (layer2 ? (effWmm + layer2Gap + effWmm) / 2 : effWmm / 2);
    svg.push('<g font-family="Arial,Helvetica,sans-serif" font-size="3.5">');
    const scoreText = isCutout ? '' : '<tspan fill="#0000FF">Blue</tspan><tspan fill="#888">=Score · </tspan>';
    svg.push('<text x="' + legendCenterX.toFixed(1) + '" y="' + gy.toFixed(1) + '" text-anchor="middle" fill="#888"><tspan fill="#FF0000" font-weight="bold">Red</tspan><tspan fill="#888">=CUT · </tspan><tspan fill="#000">Black</tspan><tspan fill="#888">=Engrave · </tspan>' + scoreText + '<tspan fill="#7EC8E3">Lt Blue</tspan><tspan fill="#888">=Light engrave (water)</tspan></text>');
    svg.push('</g>');

    svg.push('</svg>');

    const filename = (S.silhouetteName ? S.silhouetteName.replace(/[^a-z0-9]+/gi, '-').toLowerCase() : 'silhouette') + '-map-plaque.svg';
    const blob = new Blob([svg.join('\n')], { type: 'image/svg+xml' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);

  } catch(err) {
    console.error('Export error:', err);
    alert('Export failed: ' + err.message);
  } finally {
    dlBtn.disabled = false;
    dlBtn.textContent = '↓ Download SVG';
  }
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  EVENT SETUP                                                 ║
   ╚════════════════════════════════════════════════════════════════╝ */

function setupEvents() {
  $('silInput').addEventListener('keydown', function(e) { if (e.key === 'Enter') loadSilhouette(); });
  $('addressInput').addEventListener('keydown', function(e) { if (e.key === 'Enter') searchAddress(); });

  $('zoomSlider').addEventListener('input', function() {
    S.zoom = parseFloat(this.value);
    $('zoomVal').textContent = S.zoom;
    if (S.map) S.map.setZoom(S.zoom);
  });
  $('mapSizeSlider').addEventListener('input', function() {
    S.circleSize = parseInt(this.value);
    $('mapSizeVal').textContent = S.circleSize + '%';
    updatePreview(true);
  });
  $('cornerSlider').addEventListener('input', function() {
    S.cornerRadius = parseFloat(this.value);
    $('cornerVal').textContent = S.cornerRadius + ' mm';
    updateCornerOnly();
  });
  $('lineSpacingSlider').addEventListener('input', function() {
    S.lineSpacing = parseFloat(this.value);
    $('lineSpacingVal').textContent = S.lineSpacing.toFixed(1) + '×';
    updateTextPreview();
  });
  $('mainRoadSlider').addEventListener('input', function() {
    S.mainRoadWidth = parseFloat(this.value);
    $('mainRoadVal').textContent = S.mainRoadWidth.toFixed(1) + '×';
    applyRoadWidths();
  });
  $('sideRoadSlider').addEventListener('input', function() {
    S.sideRoadWidth = parseFloat(this.value);
    $('sideRoadVal').textContent = S.sideRoadWidth.toFixed(1) + '×';
    applyRoadWidths();
  });

  initSeg('detailSeg', function(v) { setDetail(v); });
  initSeg('pinSeg', function(v) { S.pin = v; updatePinOverlay(); });
  initSeg('plaqueStyleSeg', function(v) { S.plaqueStyle = v; updateDimHint(); updatePreview(); });
  initSeg('unitSeg', function(v) { switchUnit(v); });

  const textInputs = [
    { id: 'subtitleInput', key: 'subtitle' },
    { id: 'nameInput', key: 'name' },
    { id: 'locationInput', key: 'location' }
  ];
  textInputs.forEach(function(t) {
    $(t.id).addEventListener('input', function() { S[t.key] = this.value; updateTextPreview(); });
  });
  $('cutoutCaptionInput').addEventListener('input', function() {
    S.cutoutCaption = this.value;
    updateCutoutOverlay();
  });

  $('titleFontSelect').style.fontFamily = "'Cinzel', serif";
  $('nameFontSelect').style.fontFamily = "'Dancing Script', cursive";

  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updatePreview, 100);
  });

  initHoldRepeat();
}

// Press-and-hold repeat for every stepper button (silhouette/pin/caption position,
// sizes, offsets, etc). First press fires immediately; after a short delay it repeats
// on an interval until release. Falls back gracefully to a plain click if untouched.
function initHoldRepeat() {
  const HOLD_DELAY = 400, REPEAT_MS = 80;
  document.querySelectorAll('#plaque-app .step-btn[onclick]').forEach(function(btn) {
    const onclickAttr = btn.getAttribute('onclick');
    if (!onclickAttr) return;
    const run = new Function(onclickAttr);
    btn.removeAttribute('onclick');
    let holdTimer = null, repeatTimer = null, justHandledByPointer = false;
    function stop() {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      if (repeatTimer) { clearInterval(repeatTimer); repeatTimer = null; }
    }
    function start(e) {
      if (e.cancelable) e.preventDefault();
      stop();
      justHandledByPointer = true;
      try { run(); } catch (err) { console.warn('step-btn action failed', err); }
      holdTimer = setTimeout(function() {
        repeatTimer = setInterval(function() {
          try { run(); } catch (err) { console.warn('step-btn action failed', err); }
        }, REPEAT_MS);
      }, HOLD_DELAY);
    }
    btn.addEventListener('mousedown', start);
    btn.addEventListener('touchstart', start, { passive: false });
    ['mouseup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function(ev) {
      btn.addEventListener(ev, stop);
    });
    // Keyboard accessibility: Enter/Space dispatch a plain 'click' with no preceding
    // mousedown. Mouse/touch presses already ran the action via start(), so skip the
    // very next click in that case to avoid double-firing.
    btn.addEventListener('click', function() {
      if (justHandledByPointer) { justHandledByPointer = false; return; }
      try { run(); } catch (err) { console.warn('step-btn action failed', err); }
    });
  });
}

/* ╔════════════════════════════════════════════════════════════════╗
   ║  INIT                                                        ║
   ╚════════════════════════════════════════════════════════════════╝ */

function init() {
  setupEvents();
  updateDimHint();
  updatePreview();

  function bootMap() {
    if (typeof maplibregl === 'undefined') { setTimeout(bootMap, 100); return; }
    updatePreview();
    try { initMap(); } catch(e) { console.error('Map init failed:', e); return; }

    function forceResize() {
      if (!S.map) return;
      try { updatePreview(); S.map.resize(); } catch(e) {}
    }
    S.map.on('load', forceResize);
    S.map.once('idle', forceResize);
    S.map.on('error', function(e) { console.warn('Map error:', e.error); });
    [100, 300, 600, 1500].forEach(function(ms) { setTimeout(forceResize, ms); });
  }

  requestAnimationFrame(function() { updatePreview(); bootMap(); });
}

// Expose functions to global scope for HTML onclick attributes
window.adjSize = adjSize;
window.adjDim = adjDim;
window.adjTextOffset = adjTextOffset;
window.adjPinSize = adjPinSize;
window.adjSilPos = adjSilPos;
window.adjBorderWidth = adjBorderWidth;
window.adjCutoutCaptionSize = adjCutoutCaptionSize;
window.adjCutoutTextOffset = adjCutoutTextOffset;
window.adjCutoutCaptionPos = adjCutoutCaptionPos;
window.setCutoutCaptionFont = setCutoutCaptionFont;
window.searchAddress = searchAddress;
window.loadSilhouette = loadSilhouette;
window.downloadSVG = downloadSVG;
window.resetAll = resetAll;
window.setTitleFont = setTitleFont;
window.setNameFont = setNameFont;

init();

});